export default {
  getTotalEnPesos(state) {
    try {
      return state.cuentas.TOTALES[2].total;
    } catch (e) {
      return 0;
    }
  },
  getTotalEnDolar(state) {
    try {
      return state.cuentas.TOTALES[1].total;
    } catch (e) {
      return 0;
    }
  },
  getTotalEnCheque(state) {
    try {
      return state.cuentas.TOTALES[0].total;
    } catch (e) {
      return 0;
    }
  },
  getTotalEnPesosPendientes(state) {
    try {
      return state.cuentas.TOTALES[3].total;
    } catch (e) {
      return 0;
    }
  },
};
